import React, { useState } from 'react';
import styled from 'styled-components';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import { useLanguage } from '../i18n/LanguageContext';

const PageWrapper = styled.section`
  padding: 130px 20px 110px;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.96) 0%, rgba(15, 23, 42, 0.88) 50%, rgba(22, 33, 52, 0.9) 100%);
  color: #fff;
`;

const PageContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: center;
`;

const PageTitle = styled.h1`
  margin: 0;
  font-size: clamp(2.5rem, 4vw, 3.5rem);
  font-weight: 700;
`;

const IntroText = styled.p`
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.78);
`;

const TrackingCard = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  padding: 34px 32px;
  border-radius: var(--radius-lg);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(16px);
  box-shadow: 0 28px 65px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TrackingForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const InputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(15, 23, 42, 0.35);
  border-radius: var(--radius-md);
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
`;

const TrackingInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 1rem;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
`;

const TrackButton = styled.button`
  padding: 12px 28px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.95rem;
  background: linear-gradient(135deg, rgba(12, 77, 162, 1) 0%, rgba(88, 156, 237, 1) 100%);
  color: #fff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  box-shadow: 0 20px 35px rgba(12, 77, 162, 0.35);
  }
`;

const HelpText = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
`;

const UpdatesCard = styled.div`
  margin: 0 auto;
  max-width: 720px;
  padding: 32px;
  border-radius: var(--radius-lg);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(14px);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.26);
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const UpdatesTitle = styled.h2`
  margin: 0;
  font-size: 1.3rem;
  color: #fff;
`;

const UpdatesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const UpdateItem = styled.li`
  padding: 20px;
  border-radius: var(--radius-md);
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const UpdateTitle = styled.h3`
  margin: 0;
  font-size: 1.05rem;
  color: #fff;
`;

const UpdateDescription = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.6;
`;

const TrackingPage = () => {
  const { t } = useLanguage();
  const [trackingNumber, setTrackingNumber] = useState('');
  const mockUpdates = t('pages.tracking.updates');

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(t('pages.tracking.alert', { trackingNumber }));
  };

  return (
    <>
      <PageWrapper>
        <PageContainer>
          <PageTitle>{t('pages.tracking.title')}</PageTitle>
          <IntroText>{t('pages.tracking.intro')}</IntroText>
          <TrackingCard>
            <TrackingForm onSubmit={handleSubmit}>
              <InputGroup>
                <TrackingInput
                  type="text"
                  value={trackingNumber}
                  placeholder={t('pages.tracking.placeholder')}
                  onChange={(event) => setTrackingNumber(event.target.value)}
                />
                <TrackButton type="submit">{t('pages.tracking.button')}</TrackButton>
              </InputGroup>
              <HelpText>{t('pages.tracking.help')}</HelpText>
            </TrackingForm>
          </TrackingCard>
          <UpdatesCard>
            <UpdatesTitle>{t('pages.tracking.updatesTitle')}</UpdatesTitle>
            <UpdatesList>
              {mockUpdates.map((update) => (
                <UpdateItem key={update.title}>
                  <UpdateTitle>{update.title}</UpdateTitle>
                  <UpdateDescription>{update.description}</UpdateDescription>
                </UpdateItem>
              ))}
            </UpdatesList>
          </UpdatesCard>
        </PageContainer>
      </PageWrapper>
      <CTASection />
      <Footer />
    </>
  );
};

export default TrackingPage;
